<template>
  <Modal :open="open" :close="close">
    <div class="flex items-center justify-center">
      <button
        class="m-2 flex items-center font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
        @click="switchToDestop"
      >
        <IconDesktop class="w-4 h-4 mr-2" />
        desktop
      </button>
      <button
        class="m-2 flex items-center font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
        @click="switchToMobile"
      >
        <IconMobile class="w-4 h-4 mr-2" />
        phone
      </button>
    </div>
    <div
      ref="preview"
      style="zoom: 0.7"
      class="relative w-[1440px] h-[900px] ease-in-out transition-all duration-150 max-h-screen-90"
    >
      <iframe
        ref="preview_window"
        content="no-cache"
        class="z-10 w-full h-full"
        :src="`${domain}/preview-instance/?instance_shortcode=${shortCode}&status=${draft}&key=RrrgMXM57xRPsMHuj52WBqewF0vMCgBL&time=${new Date().getTime()}`"
        frameborder="0"
      ></iframe>
    </div>
  </Modal>
</template>

<script>
import { mapGetters } from "vuex";
import Modal from "@/components/Shared/Modal/Base";
import settings from "@/common/config";
import IconDesktop from "@/assets/icons/IconDesktop";
import IconMobile from "@/assets/icons/IconMobile";

export default {
  name: "ComponentPreviewModal",
  components: {
    Modal,
    IconDesktop,
    IconMobile
  },
  data() {
    return {
      status: "desktop"
    };
  },
  props: {
    close: {
      type: Function,
      required: true
    },
    open: {
      type: Boolean,
      required: true
    },
    shortCode: {
      type: String,
      required: true
    },
    draft: {
      type: String,
      required: false
    }
  },
  computed: {
    domain() {
      return this.getRegion === "au"
        ? settings.AU_API_URL
        : this.getRegion === "nz"
        ? settings.NZ_API_URL
        : settings.UK_API_URL;
    },
    ...mapGetters(["getRegion"])
  },
  methods: {
    switchToDestop() {
      this.status = "desktop";
      const preview = this.$refs.preview;
      preview.style.height = "900px";
      preview.style.width = "1440px";
    },
    switchToMobile() {
      this.status = "mobile";
      const preview = this.$refs.preview;
      preview.style.height = "896px";
      preview.style.width = "514px";
    }
  }
};
</script>
